import React from 'react';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Filter from '../../Filter';
import {
  filterData,
  restoreQueryParameters,
} from '../../Filter/utils';
import useStores from '../../../utils/useStores';
import { MEMBERSHIP_LABELS } from '../../enplus/Unternehmen/constants';

const tags = [
  'Format:Kesselhersteller',
  'Format:Ofenhersteller',
  'Format:Pellethersteller',
  'Format:Pellethändler',
  'Format:Holzbriketts: Anlagenhersteller, Produzenten und Händler',
  'Format:Hackschnitzel: Hersteller und Händler',
  'Format:Lager- und Komponentenhersteller',
  'Format:Wärmelieferung und Contracting',
  'Format:Grillhersteller',
  'Format:Pelletfachbetriebe',
  'Format:Verbände, Institutionen, sonstiges',
];

const types = ['unternehmen'];

const Mitglieder = () => {
  const { dataStore } = useStores();
  const router = useRouter();
  const { query, filters, groupFilters } = restoreQueryParameters(router.query);
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      await dataStore.companies.initialize();
      const data = dataStore.companies.all;
      setData(data);
      setIsLoading(false);
    };
    loadData();
  }, []);

  return (
    <Box mt={-14}>
      {isLoading && (
        <Box pb={4} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}
      {data && (
        <Filter
          context="depv"
          noTitle
          title="Mitglieder"
          titleProps={{
            variant: 'h2',
            'data-underline': true,
            'data-underline-less-spacing': true,
            color: 'inherit',
          }}
          searchPlaceholder="Mitglieder durchsuchen"
          groupFiltersLabel="Mitglieder filtern nach"
          data={data}
          query={query}
          groupFilters={groupFilters}
          groupBy={c => {
            return c.membership && c.membership[0];
          }}
          duplicateByKey="membership"
          isGroupValid={g => true}
          groupLabels={MEMBERSHIP_LABELS}
          filterByGroups
          queryAttributes={[
            'title',
          ]}
        />
      )}
    </Box>
  );
};

export default observer(Mitglieder);
